import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Inbox,
  Calendar,
  CheckSquare,
  FolderKanban,
  Tags,
  Users,
  FileText,
  Search,
  PanelLeftClose,
  PanelLeft,
} from 'lucide-react';

interface SidebarProps {
  open: boolean;
  onToggle: () => void;
}

const navItems = [
  { to: '/', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/inbox', icon: Inbox, label: 'Inbox' },
  { to: '/meetings', icon: Calendar, label: 'Meetings' },
  { to: '/tasks', icon: CheckSquare, label: 'Tasks' },
  { to: '/projects', icon: FolderKanban, label: 'Projects' },
  { to: '/tags', icon: Tags, label: 'Tags' },
  { to: '/people', icon: Users, label: 'People' },
  { to: '/references', icon: FileText, label: 'Reference Docs' },
  { to: '/search', icon: Search, label: 'Search' },
];

export function Sidebar({ open, onToggle }: SidebarProps) {
  return (
    <aside
      className={`bg-bg-secondary border-r border-border flex flex-col transition-all duration-200 ${
        open ? 'w-[260px]' : 'w-0 overflow-hidden'
      }`}
    >
      <div className="flex items-center justify-between h-[52px] px-4 border-b border-border">
        <span className="text-lg font-semibold text-text-primary tracking-tight">
          Dossier
        </span>
        <button
          onClick={onToggle}
          className="p-1.5 rounded-md text-text-muted hover:text-text-primary hover:bg-bg-hover transition-colors"
        >
          {open ? <PanelLeftClose size={18} /> : <PanelLeft size={18} />}
        </button>
      </div>

      <nav className="flex-1 py-2 px-2 space-y-0.5 overflow-y-auto">
        {navItems.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors ${
                isActive
                  ? 'bg-accent/10 text-accent'
                  : 'text-text-secondary hover:text-text-primary hover:bg-bg-hover'
              }`
            }
          >
            <Icon size={18} />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="px-4 py-2 border-t border-border">
        <span className="text-[10px] text-text-muted">v{__APP_VERSION__}</span>
      </div>
    </aside>
  );
}
